import Router from './routes/Router';

//styles
import 'bootstrap/dist/css/bootstrap.min.css';
import './stylesheets/app.scss';
import { BrowserRouter } from 'react-router-dom';
import { MsalProvider } from '@azure/msal-react';
import { ClientSideNavigation } from './services/auth';

function App({ pca }: any) {
    return (
        <>
            <BrowserRouter>
                <ClientSideNavigation pca={pca}>
                    <MsalProvider instance={pca}>
                        <Router />
                    </MsalProvider>
                </ClientSideNavigation>
            </BrowserRouter>
        </>
    );
}

export default App;
